export const buildWindowFormFieldMap = (definition) => {
  const map = new Map();
  (definition?.sections || []).forEach((section) => {
    (section.fields || []).forEach((field) => {
      if (field?.id) {
        map.set(field.id, field);
      }
    });
  });
  return map;
};

export const getWindowFormFieldOptions = (fieldMap, fieldId, fallback = []) => {
  if (!fieldMap) {
    return fallback;
  }
  const field = fieldMap.get(fieldId);
  if (
    field?.type === "dropdown" &&
    Array.isArray(field.options) &&
    field.options.length
  ) {
    return field.options;
  }
  return fallback;
};

export const getWindowFormCustomSections = (definition) =>
  (definition?.sections || []).filter((section) => section.kind !== "builtin");

const toComparableValue = (value) => {
  if (value === null || value === undefined) {
    return "";
  }
  return `${value}`.trim().toLowerCase();
};

export const evaluateWindowFormFieldVisibility = (
  field,
  values = {},
  rowValues = null
) => {
  const conditions = Array.isArray(field?.conditions) ? field.conditions : [];
  if (!conditions.length) {
    return true;
  }

  const mode = field?.condition_match === "any" ? "any" : "all";
  const results = conditions
    .filter((condition) => condition?.field_id)
    .map((condition) => {
      const sourceValue =
        rowValues && rowValues[condition.field_id] !== undefined
          ? rowValues[condition.field_id]
          : values?.[condition.field_id];
      return (
        toComparableValue(sourceValue) === toComparableValue(condition.value)
      );
    });

  if (!results.length) {
    return true;
  }
  return mode === "any" ? results.some(Boolean) : results.every(Boolean);
};

const mergeFieldLists = (baseFields = [], savedFields = []) => {
  const savedById = new Map(savedFields.map((field) => [field.id, field]));
  const merged = baseFields.map((field) => {
    const saved = field.id ? savedById.get(field.id) : null;
    return saved ? { ...field, ...saved } : field;
  });
  const mergedIds = new Set(merged.map((field) => field.id));
  savedFields.forEach((field) => {
    if (field?.id && !mergedIds.has(field.id)) {
      merged.push(field);
    }
  });
  return merged;
};

export const mergeWindowFormDefinition = (baseDefinition, savedDefinition) => {
  const baseSections = baseDefinition?.sections || [];
  const savedSections = savedDefinition?.sections || [];
  const savedById = new Map(savedSections.map((section) => [section.id, section]));
  const mergedSections = baseSections.map((section) => {
    const saved = section.id ? savedById.get(section.id) : null;
    if (!saved) {
      return section;
    }
    return {
      ...section,
      ...saved,
      fields: mergeFieldLists(section.fields || [], saved.fields || []),
    };
  });
  const mergedIds = new Set(mergedSections.map((section) => section.id));
  savedSections.forEach((section) => {
    if (section?.id && !mergedIds.has(section.id)) {
      mergedSections.push(section);
    }
  });
  return {
    ...baseDefinition,
    ...savedDefinition,
    sections: mergedSections,
  };
};
